/**
 * ⚠️ TEMP — DO NOT COMMIT. Local connectivity smoke test.
 *
 * Proves the Supabase client reaches the tenant over the network. Uses a bogus
 * sign-in as the probe: a 4xx response means the round trip worked (server
 * rejected the fake credentials); a thrown/network error means it did not.
 * Logs to the browser console. Delete before committing.
 */
import { getSupabaseClient } from './supabase-client';

(async () => {
  try {
    const client = getSupabaseClient();
    const { error } = await client.auth.signInWithPassword({
      email: 'smoketest@example.com',
      password: 'connectivity-probe-not-a-real-account',
    });

    if (!error) {
      // eslint-disable-next-line no-console
      console.log(
        '[SUPABASE SMOKE] CONNECTED ✅ (probe unexpectedly succeeded)'
      );
    } else if (error.status >= 400 && error.status < 500) {
      // eslint-disable-next-line no-console
      console.log(
        `[SUPABASE SMOKE] CONNECTED ✅ — tenant reachable, server responded ` +
          `${error.status}: ${error.message}`
      );
    } else {
      // eslint-disable-next-line no-console
      console.error(
        `[SUPABASE SMOKE] NOT CONNECTED ❌ — ${error.name}: ${error.message} ` +
          `(status ${error.status})`
      );
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[SUPABASE SMOKE] FAILED ❌ — threw:', e);
  }
})();
